// Pages légales + contact — français.
const legal = {
  betAmount: '100 $',
  supportHours: '9h – 23h, 7j/7',
  supportDelay: 'moins d’une heure',

  shell: {
    updated: d => `Dernière mise à jour : ${d}`
  },

  contact: {
    title: 'Nous écrire',
    // `null` explicite, comme en anglais : la page contact est la seule sans
    // date de mise à jour. Sans cette ligne le français héritait de la valeur
    // anglaise — même résultat, mais l'asymétrie ressortait à chaque contrôle
    // de parité des clés.
    updated: null,
    intro: (delay, hours) =>
      `Une question avant de commencer, un problème d’installation, une
       demande de remboursement : on répond en ${delay}, ${hours}.`,
    emailN: 'E-mail',
    emailS: 'Le plus sûr pour tout ce qui touche à ton compte ou à un paiement.',
    whatsappS: 'Le plus rapide, pour tout : installation, facture, résiliation.',
    openChat: 'Ouvrir la conversation',
    waMsg: 'Bonjour, j’ai une question sur SELFCNTRL.',
    fastT: 'Ce qu’on te répondra vite',
    fastP: days => `Un problème d’installation sur ton appareil, un profil qui
      ne se verrouille pas, une facture, une résiliation, une demande de
      remboursement dans les ${days} jours : ce sont des demandes qu’on traite
      dans la foulée.`,
    cantT: 'Ce qu’on ne pourra pas faire',
    cantP1: hours => <><b>Retirer ton verrou plus vite que le délai de {hours} heures.</b> Ce délai est le cœur du produit : si le support pouvait le contourner, il suffirait d’un message un soir de faiblesse pour tout défaire. On ne fera pas d’exception, même en insistant — et c’est précisément ce que tu es venu acheter.</>,
    cantP2: `On ne peut pas non plus te dire ce que tu as consulté : nous ne
             conservons aucun historique de navigation. Ce n’est pas une
             posture, c’est une impossibilité technique.`,
    betT: amount => `Réclamer le pari à ${amount}`,
    betP1: 'Écris-nous à ',
    betP2: ' en décrivant la méthode utilisée pour retirer le filtre. Les conditions sont détaillées dans la ',
    betLink: 'politique de remboursement',
    gdprT: 'Protection des données',
    gdprP: `Pour toute demande d’accès, de rectification ou de suppression de
            tes données, la même adresse suffit. On répond sous un mois au
            maximum, comme l’exige le règlement européen — en pratique, bien
            plus vite.`
  },

  mentions: {
    title: 'Mentions légales',
    updated: '28 juillet 2026',
    intro: 'Informations relatives à l’éditeur et à l’hébergeur du site SELFCNTRL.',
    publisherT: 'Éditeur du site',
    name: 'Dénomination',
    form: 'Forme juridique',
    capital: 'Capital social',
    address: 'Siège social',
    registration: 'Immatriculation',
    vat: 'TVA intracommunautaire',
    director: 'Directeur de la publication',
    contact: 'Contact',
    hostT: 'Hébergeur',
    hostName: 'Dénomination',
    hostAddress: 'Adresse',
    hostPhone: 'Téléphone',
    ipT: 'Propriété intellectuelle',
    ipP: `L’ensemble des éléments du site — textes, interface, code, marque
          SELFCNTRL — est protégé par le droit de la propriété intellectuelle.
          Toute reproduction ou réutilisation, même partielle, sans
          autorisation écrite préalable est interdite.`,
    artT: 'Illustrations',
    artP1: 'Certaines illustrations utilisées sur ce site sont l’œuvre de tiers. Toute demande relative à leur usage peut être adressée à ',
    artP2: ', et sera traitée sans délai.',
    reportT: 'Signalement',
    reportP: `Conformément à la loi pour la confiance dans l’économie numérique,
              tout contenu manifestement illicite peut être signalé à l’adresse
              ci-dessus.`
  },

  cgv: {
    title: 'Conditions générales',
    updated: '26 septembre 2026',
    intro: `Ces conditions régissent l’utilisation du service SELFCNTRL et la
            vente des abonnements. En créant un compte, tu les acceptes.`,
    s1T: '1. Objet',
    s1P: `SELFCNTRL est un service de filtrage de contenu qui bloque l’accès
          aux sites pornographiques sur les appareils que tu lui confies, et
          rend ce blocage volontairement difficile à retirer. Le service
          s’adresse exclusivement à des personnes majeures qui souhaitent
          restreindre leur propre accès.`,
    s2T: '2. Compte',
    s2P: `La création d’un compte requiert une adresse e-mail valide et un mot
          de passe. Tu es responsable de la confidentialité de ce mot de passe
          et des actions effectuées depuis ton compte. Un compte est
          personnel : il ne peut être ni partagé ni cédé.`,
    s3T: '3. Nature du verrou',
    s3P: <><b>Le service est conçu pour ne pas pouvoir être désactivé sur un coup de tête.</b> C’est sa fonction, pas un défaut. Concrètement :</>,
    s3Items: hours => [
      'le filtrage s’applique en continu sur les appareils verrouillés ;',
      `le retrait d’un profil ouvre un délai de réflexion de ${hours} heures avant que le mot de passe de désinstallation ne soit communiqué ;`,
      'en sevrage progressif, le nombre de jours verrouillés par semaine peut être augmenté à tout moment, mais jamais diminué en dessous du palier déjà atteint ;',
      'le support ne peut ni raccourcir ces délais ni contourner ces règles, quelle que soit l’insistance.'
    ],
    s3After: 'En souscrivant, tu reconnais comprendre et vouloir ces limitations.',
    s4T: '4. Prix et paiement',
    s4P: `Deux formules sont proposées : un abonnement mensuel et un
          abonnement annuel. Les prix affichés sont en dollars US,
          toutes taxes comprises. Le paiement est traité par Stripe sur une
          page sécurisée ; aucune donnée bancaire ne transite par nos serveurs
          ni n’est conservée par nous.`,
    renewT: 'Reconduction',
    renewP: `Les deux abonnements se renouvellent automatiquement à la fin de
             chaque période — chaque mois pour le mensuel, chaque année pour
             l’annuel — jusqu’à résiliation. La résiliation prend effet à la fin de la
             période en cours ; aucun prorata n’est remboursé pour la période
             entamée, hors cas prévus à l’article 6.`,
    s5T: '5. Droit de rétractation',
    s5P: `Le service étant un contenu numérique fourni immédiatement, tu es
          informé qu’en demandant son exécution immédiate tu renonces à ton
          droit légal de rétractation de quatorze jours, conformément à
          l’article L.221-28 du Code de la consommation.`,
    s5P2a: <><b>Nous allons volontairement au-delà</b> : voir la </>,
    s5Link: 'politique de remboursement',
    s5P2b: days => `, qui accorde ${days} jours sans justification.`,
    s6T: '6. Résiliation',
    s6P1: `Tu peux résilier à tout moment depuis ton espace client, sans motif
           et sans frais. Nous pouvons suspendre ou fermer un compte en cas
           d’impayé, d’usage frauduleux, de partage du compte ou de tentative
           de contournement du service à des fins de revente.`,
    s6P2: <>À la résiliation, le filtrage cesse d’être appliqué. <b>L’accès à Internet n’est jamais coupé</b> : seule la règle de blocage est désactivée.</>,
    s7T: '7. Disponibilité',
    s7P: `Nous mettons tout en œuvre pour assurer la continuité du service, sans
          pouvoir garantir une disponibilité ininterrompue. Le filtrage repose
          sur des infrastructures tierces et sur la connexion de tes appareils :
          une panne de réseau, une modification du système d’exploitation ou
          une manipulation de ta part peuvent le rendre temporairement
          inopérant.`,
    s8T: '8. Responsabilité',
    s8P: `SELFCNTRL est un outil d’aide, pas un traitement médical. Il ne
          remplace ni un accompagnement psychologique ni un avis professionnel.
          Notre responsabilité ne saurait être engagée au titre d’une rechute,
          d’un contournement du filtrage, ni des conséquences indirectes de
          l’usage du service.`,
    s9T: '9. Modification des conditions',
    s9P: `Ces conditions peuvent évoluer. Toute modification substantielle sera
          notifiée par e-mail au moins trente jours avant son entrée en
          vigueur, avec possibilité de résilier sans frais.`,
    s10T: '10. Droit applicable et litiges',
    s10P1: `Les présentes conditions sont soumises au droit français. En cas de
            différend, une solution amiable sera recherchée en priorité :
            écris-nous à `,
    s10P2: `Conformément à l’article L.612-1 du Code de la consommation, tu peux
            recourir gratuitement à un médiateur de la consommation. Tu peux
            aussi utiliser la plateforme européenne de règlement en ligne des
            litiges.`
  },

  privacy: {
    title: 'Confidentialité',
    updated: '28 juillet 2026',
    intro: `Ce que nous collectons, pourquoi, combien de temps, et surtout ce
            que nous ne collectons pas.`,
    notT: 'Ce que nous ne collectons pas',
    notP1: <><b>Nous ne conservons aucun historique de navigation.</b> Le filtrage fonctionne par catégories entières au niveau du DNS : le système sait qu’une catégorie est bloquée, il ne tient pas la liste des sites que tu as tenté d’ouvrir. Personne, chez nous, ne peut savoir ce que tu as consulté — ni te le dire si tu le demandais.</>,
    notP2: `Nous ne recevons ni ne stockons aucune donnée bancaire. Nous ne
            vendons aucune donnée, à personne, jamais.`,
    doT: 'Ce que nous collectons',
    accountT: 'Pour faire fonctionner ton compte',
    accountItems: [
      'ton adresse e-mail, et un nom d’affichage déduit de celle-ci ;',
      'ton mot de passe, stocké sous forme chiffrée irréversible ;',
      'ton compteur de jours tenus, ton record et le nombre de rechutes déclarées ;',
      'tes objectifs et leur avancement ;',
      'le nom, le type et l’identifiant technique des appareils que tu verrouilles ;',
      'tes horaires de coupure et ton rythme de sevrage.'
    ],
    payT: 'Pour le paiement',
    payItems: [
      'ton identifiant client chez notre prestataire de paiement, l’état et la date de fin de ton abonnement.'
    ],
    adsT: 'Pour mesurer nos publicités',
    adsItems: [
      'l’identifiant de clic publicitaire, ton adresse IP et ton navigateur au moment de l’inscription, conservés pour rattacher un achat à une campagne.'
    ],
    optT: 'Si tu choisis d’y participer',
    optItems: [
      <>le pseudonyme que tu choisis pour le classement. <b>Ton prénom et ton adresse e-mail n’y apparaissent jamais</b>, et la participation se retire d’un clic.</>
    ],
    basisT: 'Bases légales',
    basisP: `Les données de compte et de paiement sont traitées pour l’exécution
             du contrat qui nous lie. Les données publicitaires reposent sur
             ton consentement, révocable à tout moment. La participation au
             classement repose sur ton consentement explicite.`,
    whoT: 'Qui reçoit ces données',
    processors: {
      stripe: {
        role: 'Paiement et gestion des abonnements',
        data: 'Adresse e-mail, données de carte (jamais transmises à nos serveurs), historique de facturation',
        where: 'Union européenne et États-Unis'
      },
      cloudflare: {
        role: 'Filtrage DNS des appareils protégés',
        data: 'Requêtes DNS des appareils verrouillés, rattachées à un identifiant technique anonyme',
        where: 'Réseau mondial'
      },
      meta: {
        role: 'Mesure de l’efficacité publicitaire',
        data: 'Adresse e-mail sous forme chiffrée à sens unique, montant et date de l’achat',
        where: 'Union européenne et États-Unis'
      },
      host: {
        role: 'Hébergement du site et de la base de données',
        data: 'L’ensemble des données du compte',
        where: 'France'
      }
    },
    hosting: where => `Hébergement : ${where}.`,
    transferP: `Les transferts hors Union européenne sont encadrés par les
                clauses contractuelles types de la Commission européenne.`,
    keepT: 'Durée de conservation',
    keepItems: [
      'Données de compte : tant que ton compte existe, puis trente jours après sa suppression ;',
      'Factures : dix ans, comme l’impose la loi comptable ;',
      'Données publicitaires : treize mois maximum ;',
      'Sessions de connexion : sept jours.'
    ],
    rightsT: 'Tes droits',
    rightsP1: `Tu disposes d’un droit d’accès, de rectification, d’effacement, de
               limitation, d’opposition et de portabilité. Une seule adresse
               pour tout : `,
    rightsP2: '. Nous répondons sous un mois au maximum, en pratique bien plus vite.',
    rightsP3: 'Tu peux également introduire une réclamation auprès de la CNIL.',
    cookiesT: 'Cookies et mesure d’audience',
    cookiesP: `Le site dépose un identifiant de session nécessaire à ta
               connexion, qui ne requiert pas de consentement. Les traceurs
               publicitaires ne sont activés qu’après ton accord, et le refus
               n’enlève rien au fonctionnement du service.`,
    secT: 'Sécurité',
    secP: `Les échanges sont chiffrés, les mots de passe stockés sous forme
           irréversible, et l’accès aux données limité aux seules personnes qui
           en ont besoin. Aucun système n’étant infaillible, nous
           t’informerions sans délai en cas de violation de données te
           concernant.`
  },

  refund: {
    title: 'Remboursement et garantie',
    updated: '26 septembre 2026',
    intro: (days, amount) =>
      `${days} jours pour changer d’avis sans avoir à te justifier, et
       ${amount} si tu arrives à retirer le verrou par tes propres moyens.`,
    refundT: days => `Remboursement à ${days} jours`,
    refundP1a: days => `Si le service ne te convient pas, écris-nous dans les
      ${days} jours suivant ton paiement à `,
    refundP1b: <>. <b>Aucune justification ne t’est demandée</b> et le remboursement est intégral. Il s’applique au premier paiement de chacune des deux formules, mensuelle ou annuelle.</>,
    refundP2: `Le remboursement est effectué sur le moyen de paiement d’origine
               sous quatorze jours, généralement bien plus vite.`,
    betT: amount => `Le pari à ${amount}`,
    betP: amount => <>Si tu parviens à retirer le filtrage d’un appareil verrouillé par nos soins, par tes propres moyens, nous te versons {amount} <b>en plus</b> du remboursement intégral de ton abonnement.</>,
    countsT: 'Ce qui compte',
    countsItems: [
      'désinstaller le profil de configuration sans utiliser le mot de passe que nous t’aurions communiqué ;',
      'désactiver durablement le filtrage tout en gardant l’appareil supervisé ;',
      'accéder à un site d’une catégorie bloquée depuis l’appareil verrouillé, sans modifier sa configuration réseau.'
    ],
    notCountsT: 'Ce qui ne compte pas',
    notCountsItems: hours => [
      'utiliser un autre appareil, non verrouillé ;',
      'réinitialiser l’appareil aux réglages d’usine, ce qui efface tout, y compris tes données ;',
      `employer le mot de passe de désinstallation obtenu au terme du délai de ${hours} heures — c’est le fonctionnement normal, pas un contournement ;`,
      'résilier l’abonnement, ce qui désactive volontairement le filtrage ;',
      'un appareil qui n’a jamais été supervisé, ou dont la supervision a échoué.'
    ],
    claimT: 'Comment réclamer',
    claimP: delay => `Écris-nous en décrivant précisément la méthode employée,
      avec de quoi la reproduire. Nous répondons sous ${delay} et procédons à
      la vérification. Si la méthode fonctionne, tu es payé — et nous
      corrigeons la faille.`,
    limitsT: 'Limites',
    limitsItems: [
      'une réclamation par personne et par compte ;',
      'l’appareil doit avoir été verrouillé via SELFCNTRL et l’abonnement actif au moment de la tentative ;',
      'la méthode doit être reproductible : un contournement lié à une panne temporaire de nos prestataires ne compte pas.'
    ],
    notT: 'Ce que le remboursement ne fait pas',
    notP1: <>Demander un remboursement met fin à ton abonnement et coupe le filtrage, mais <b>ne retire pas le profil déjà installé sur tes appareils</b>. Pour cela, il faut passer par la demande de retrait et son </>,
    notP2: hours => `délai de ${hours} heures, décrite dans les `,
    notLink: 'conditions générales'
  }
}

export default legal
